module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-combined-1-macbook.eb5f3381.png";